"use client";

import React from "react";
import { LayoutGrid, Sparkles, Route, Sun, Trees, Fence, BrickWall, Grip, Layers } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servicesData = [{
  title: "Portable Toilets",
  description: "Standard and deluxe units for high-traffic sites and short-term rentals across the nation.",
  icon: LayoutGrid
}, {
  title: "ADA Compliant Units",
  description: "Fully compliant, spacious portable restrooms ensuring accessibility for all guests and workers.",
  icon: BrickWall
}, {
  title: "Luxury Restroom Trailers",
  description: "High-end mobile restrooms featuring climate control, premium finishes, and modern amenities.",
  icon: Sparkles
}, {
  title: "Shower Trailers",
  description: "Clean, private mobile shower facilities for festivals, campsites, and emergency response.",
  icon: Layers
}, {
  title: "Handwash Stations",
  description: "Specialized sanitation stations equipped with soap dispensers and hands-free foot pumps.",
  icon: Grip
}, {
  title: "Event Sanitation",
  description: "Comprehensive sanitation management for festivals, stadiums, and large-scale public gatherings.",
  icon: Sun
}, {
  title: "Construction Site Services",
  description: "Rugged, reliable sanitation solutions built to withstand demanding industrial environments.",
  icon: Fence
}, {
  title: "Emergency Response",
  description: "Rapid-deployment sanitation and logistics for disaster relief and municipal emergencies.",
  icon: Route
}, {
  title: "Multi-Location Solutions",
  description: "Scalable sanitation programs designed for national enterprise clients with diverse regional needs.",
  icon: Trees
}];
export default function OurPavingLandscapingExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222733" id="enterprise-fleet-solutions" className="bg-muted py-24 text-foreground">
      <div className="container mx-auto max-w-7xl px-4 md:px-8">
        <div className="mb-16 text-center">
          <h2 className="font-default text-secondary mb-4 text-3xl font-bold md:text-4xl lg:text-5xl">
            Enterprise Fleet Solutions
          </h2>
          <p className="text-muted-foreground mx-auto max-w-2xl text-lg font-default">
            National portable sanitation solutions for every industry. From major construction sites to luxury events, we provide reliable, fast, and certified service anywhere in the country.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
          {servicesData.map((service, i) => {
          const Icon = service.icon;
          return <div key={service.title} data-index={i} className="group bg-card border-border hover:border-primary hover:shadow-lg flex flex-col items-center rounded-xl border p-12 text-center transition-all duration-300">
                <div className="text-primary mb-6 transition-transform duration-300 group-hover:rotate-6">
                  <Icon className="size-12" strokeWidth={1.5} />
                </div>
                <h3 className="font-default text-secondary mb-4 text-xl font-bold">
                  {service.title}
                </h3>
                <p className="text-muted-foreground text-base leading-relaxed font-default">
                  {service.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}